import React from 'react';
import { useLanguage } from '../../contexts';
import { Question } from '../../types/quiz';
import OptionCard from './OptionCard';
import ProgressBar from '../common/ProgressBar';

interface Props {
  question: Question;
  currentIndex: number;
  totalQuestions: number;
  onAnswer: (optionId: string) => void;
}

const QuestionCard: React.FC<Props> = ({
  question,
  currentIndex,
  totalQuestions,
  onAnswer,
}) => {
  const { isRTL } = useLanguage();

  return (
    <div className="flex flex-col gap-6" dir={isRTL ? 'rtl' : 'ltr'}>
      {/* Progress */}
      <ProgressBar current={currentIndex} total={totalQuestions} />

      {/* Question */}
      <div className="bg-white rounded-2xl shadow-sm p-6">
        <h2 className="text-lg font-bold text-gray-800 text-center leading-snug">
          {question.text}
        </h2>
      </div>

      {/* Options grid */}
      <div className="grid grid-cols-2 gap-3">
        {question.options.map((option) => (
          <OptionCard
            key={option.id}
            option={option}
            selected={false}
            onSelect={onAnswer}
          />
        ))}
      </div>
    </div>
  );
};

export default QuestionCard;
